import { useCallback, useState } from 'react';
import { useAppSelector } from './redux';

/**
 * Reusable guard for destructive navigations and reset actions.
 * If the layout has unsaved changes (isDirty = true), prompts the user
 * with Stay | Leave Without Saving before executing the action.
 * Also intercepts browser beforeunload events to prevent silent data loss.
 */
export function useUnsavedChangesGuard() {
  const isDirty = useAppSelector((state) => state.layout.isDirty);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [showModal, setShowModal] = useState(false);

  // Temporarily disabled: the popup was appearing even when there were no
  // real unsaved changes (isDirty is being set too aggressively).
  // Restore the beforeunload + modal prompt when dirty-tracking is fixed.
  /*
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
  */

  const requestAction = useCallback(
    (action: () => void) => {
      action();
      /*
      if (!isDirty) {
        action();
        return;
      }
      setPendingAction(() => action);
      setShowModal(true);
      */
    },
    []
  );

  const handleStay = useCallback(() => {
    setShowModal(false);
    setPendingAction(null);
  }, []);

  const handleLeave = useCallback(() => {
    setShowModal(false);
    const action = pendingAction;
    setPendingAction(null);
    if (action) {
      action();
    }
  }, [pendingAction]);

  return {
    isDirty,
    showModal,
    requestAction,
    handleStay,
    handleLeave,
  };
}

export default useUnsavedChangesGuard;
